import {ErrorStateScheduleEnum} from '../../error-state-schedule.enum';

export enum CompanyFormErrorStatesEnum {
    CompanyRegistrationFailed = ErrorStateScheduleEnum.CompanyFormStatesStartIndex,
    GetCompanyFailed,
    UpdateCompanyFailed
}
